import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types';

export type DeviceData = PromiseType<ReturnType<typeof DeviceManager.getSierraGatewayDeviceDetails>>;
type ContextState = Data<DeviceData>;
const Context = React.createContext<ContextState | null>(null);

function useSierraGatewayDeviceDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSierraGatewayDeviceDetails must be used within a SierraGatewayDeviceDetailsProvider');
    }
    return contextState;
}

const SierraGatewayDeviceDetailsProvider: React.FC<{ deviceId: string ;siteId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'sierra-gateway-device-details',
        id: props.deviceId,
        dataFn: React.useCallback(() => DeviceManager.getSierraGatewayDeviceDetails(authHelper, props.deviceId,
            props.siteId), [
            authHelper,
            props.deviceId, props.siteId
        ]),
    });

    const deviceDetailsData = dataFromDataset(dataset);

    return <Context.Provider value={deviceDetailsData}>{props.children}</Context.Provider>;
};

const TestDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SierraGatewayDeviceDetailsProvider, TestDeviceDataProvider, useSierraGatewayDeviceDetails };
